// src/lib/openExternal.ts
declare global {
  interface Window {
    JULYUPAY?: {
      openExternal?: (url: string) => void;
    };
    ReactNativeWebView?: {
      postMessage?: (message: string) => void;
    };
    webkit?: {
      messageHandlers?: {
        openExternal?: {
          postMessage?: (message: string) => void;
        };
      };
    };
  }
}

export const DEFAULT_KAKAO_CHAT_URL = "https://pf.kakao.com/_lzHxen/chat";

export function getKakaoChatUrl(): string {
  return (
    (import.meta.env.VITE_KAKAO_CHANNEL_CHAT_URL as string | undefined)?.trim() ||
    DEFAULT_KAKAO_CHAT_URL
  );
}

export function isValidKakaoPfUrl(url: string): boolean {
  const u = String(url || "").trim();
  return /^https:\/\/pf\.kakao\.com\/.+/i.test(u);
}

export function isAppWebView(): boolean {
  if (typeof window === "undefined") return false;
  const ua = window.navigator.userAgent || "";
  // 필요하면 앱 UA 토큰 추가
  return /JULYUPAY_APP|androidApp|; wv\)/i.test(ua);
}

export function hasBridge(): boolean {
  return Boolean(
    window.JULYUPAY?.openExternal ||
      window.ReactNativeWebView?.postMessage ||
      window.webkit?.messageHandlers?.openExternal?.postMessage
  );
}

/** Markers used by the installed app and newer wrappers. */
export function isJulyupayApp(): boolean {
  return typeof window !== "undefined" && /JULYUPAY_APP|androidApp/i.test(window.navigator.userAgent || "");
}

export function tryOpenExternal(url: string): boolean {
  try {
    if (window.JULYUPAY?.openExternal) {
      window.JULYUPAY.openExternal(url);
      return true;
    }

    if (window.ReactNativeWebView?.postMessage) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: "openExternal", url })
      );
      return true;
    }

    if (window.webkit?.messageHandlers?.openExternal?.postMessage) {
      window.webkit.messageHandlers.openExternal.postMessage(url);
      return true;
    }
  } catch {
    // no-op
  }
  return false;
}

/**
 * 외부 링크 오픈 공통 함수
 * 1) 브릿지 시도
 * 2) 앱 웹뷰면 같은 창 이동
 * 3) 일반 브라우저는 새 탭 후 실패 시 같은 창 이동
 */
export function openExternalUrl(url: string): void {
  const target = String(url || "").trim();

  if (!target) return;

  if (tryOpenExternal(target)) return;

  const inApp = isAppWebView() || hasBridge();

  if (inApp) {
    // user gesture 문맥에서 즉시 이동
    window.location.assign(target);
    return;
  }

  const win = window.open(target, "_blank", "noopener,noreferrer");
  if (!win) {
    window.location.assign(target);
  }
}
